import axiosInstance from "../../api/axiosInstance";

// plan "prime": شات البرايم — Prime players' chats only. Params are encoded
// by axios, so a search like "a&b" or "#1" reaches the server intact.
export const fetchChatsAPI = ({ page = 1, limit = 20, username = "", plan = "all" }) => {
  return axiosInstance.get("/supportChat/get-all-chats", {
    params: {
      page,
      limit,
      ...(username ? { username } : {}),
      ...(plan === "prime" ? { plan: "prime" } : {}),
    },
  });
};

export const fetchChatMessagesAPI = (chatId, params = {}) => {
  return axiosInstance.get(`supportChat/${chatId}/messages`, {
    params,
  });
};

export const sendSupportMessageAPI = (chatId, message) => {
  return axiosInstance.post(`supportChat/${chatId}/message`, { message });
};

export const updateSupportMessageAPI = (chatId, messageId, message) => {
  return axiosInstance.patch(
    `supportChat/${chatId}/messages/${messageId}`,
    { message }
  );
};

export const deleteSupportMessageAPI = (chatId, messageId) => {
  return axiosInstance.delete(
    `supportChat/${chatId}/messages/${messageId}`
  );
};

export const markMessagesAsReadByAdminAPI = (chatId) => {
  return axiosInstance.patch(`supportChat/${chatId}/mark-read-by-admin`);
};

export const updateChatAccessAPI = async (userId, access) => {
  const response = await axiosInstance.patch(`users/${userId}/chat-access`, {
    access,
  });
  return response.data;
};
